<template>
  <div class="home">
    <LandingSplash />

    <!-- Feature cards that link to subsections -->
    <Section medium>
      <v-col cols="12" class="mx-auto">
        <div class="card-grid">
          <router-link class="home-card reveal" to="/about">
            <div class="image">
              <v-img class="about-img" height="100%" :src="require('@/assets/urc.jpg')" />
            </div>
            <div class="content">
              <h2>About Us</h2>
              <p>
                Learn about our team, our mission, and our work on competition rovers.
              </p>
              <span class="cta">Learn More</span>
            </div>
          </router-link>

          <router-link class="home-card reveal" to="/donate">
            <div class="image white-bg">
              <v-img
                class="sponsor-img"
                height="100%"
                :src="require('@/assets/sponsors/ucsdmakerspace.png')"
                contain
              />
            </div>
            <div class="content">
              <h2>Sponsors</h2>
              <p>
                We couldn't do this without our sponsors. See everyone who helps us build.
              </p>
              <span class="cta">Learn More</span>
            </div>
          </router-link>

          <router-link class="home-card reveal" to="/recruitment">
            <div class="image">
              <v-img class="contact-img" height="100%" :src="require('@/assets/contact.png')" />
            </div>
            <div class="content">
              <h2>Contact Us</h2>
              <p>
                Interested in joining or collaborating? Reach out and get involved.
              </p>
              <span class="cta">Learn More</span>
            </div>
          </router-link>
        </div>
      </v-col>
    </Section>

    <!-- Join Us -->
    <SplitSection medium>
      <template v-slot:right>
        <v-img class="shrink mr-2" contain :src="require('@/assets/team.jpg')" />
      </template>
      <template v-slot:left>
        <div class="project-card reveal">
          <div class="accent" />
          <div class="body">
            <h1>Join Us</h1>
            <p>
              Our application for the 2026-2027 season is now open! Apply
              <a
                target="_blank"
                href="https://docs.google.com/forms/d/e/1FAIpQLSeafR0AfzTdKzEQfA5Ua9tDNp2EJuMX5LQWS6M7LI-oenVVUQ/viewform?usp=header"
                >here.</a
              >
              <br />
              Applications close October 9th at 11:59 PM
              <br /><br />
              Keep up with what we are doing on our
              <a target="_blank" href="https://www.instagram.com/yonderdynamics/">
                Instagram
              </a>
              or
              <a target="_blank" href="https://www.facebook.com/yonderdynamics/">
                Facebook
              </a>
              pages.
            </p>
          </div>
        </div>

        <!-- Social links card -->
        <div class="social-card reveal">
          <div class="social-title">
            <strong class="yonder-title-small">YONDER DYNAMICS</strong>
          </div>
          <p class="address">9500 Gilman Dr, La Jolla, CA 92093</p>
          <div class="icon-row">
            <a
              class="icon-link"
              target="_blank"
              rel="noopener"
              href="https://www.instagram.com/yonderdynamics/"
              aria-label="Instagram"
            >
              <div class="icon-circle">
                <v-icon>mdi-instagram</v-icon>
              </div>
            </a>
            <a
              class="icon-link"
              target="_blank"
              rel="noopener"
              href="https://www.facebook.com/yonderdynamics/"
              aria-label="Facebook"
            >
              <div class="icon-circle">
                <v-icon>mdi-facebook</v-icon>
              </div>
            </a>
            <a
              class="icon-link"
              target="_blank"
              rel="noopener"
              href="https://linktr.ee/yonderdynamics"
              aria-label="Linktree"
            >
              <div class="icon-circle">
                <v-icon>mdi-link-variant</v-icon>
              </div>
            </a>
            <a
              class="icon-link"
              target="_blank"
              rel="noopener"
              href="https://www.youtube.com/@yonderdynamics"
              aria-label="YouTube"
            >
              <div class="icon-circle">
                <v-icon>mdi-youtube</v-icon>
              </div>
            </a>
            <a class="icon-link" href="mailto:yonderdynamics@ucsd.edu" aria-label="Email">
              <div class="icon-circle">
                <v-icon>mdi-email-outline</v-icon>
              </div>
            </a>
          </div>
        </div>
      </template>
    </SplitSection>
  </div>
</template>
<script>
import LandingSplash from "@/components/LandingSplash.vue";
import Section from "@/components/Section.vue";
import SplitSection from "@/components/SplitSection.vue";

export default {
  name: "Home",
  components: {
    LandingSplash,
    Section,
    SplitSection,
  },
  mounted() {
    // lazy-load iframes (if any)
    const vidDefer = document.getElementsByTagName("iframe");
    for (let i = 0; i < vidDefer.length; i += 1) {
      if (vidDefer[i].getAttribute("data-src")) {
        vidDefer[i].setAttribute("src", vidDefer[i].getAttribute("data-src"));
      }
    }
    // reveal animations
    const els = this.$el.querySelectorAll(".reveal");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.15 },
    );
    els.forEach((el) => io.observe(el));
  },
};
</script>
<style scoped>
.video-container {
  position: relative;
  overflow: hidden;
  height: 0;
  padding-bottom: 56.25%;
}
.apply-p {
  border-bottom: 5px;
  padding-bottom: 5px;
}
.video-wrap {
  width: 100%;
  max-width: 1000px;
  margin: auto;
}
.video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-height: 100%;
}
#signature {
  float: right;
  font-size: 2em;
}
a {
  color: white;
}
a:visited {
  color: white;
}
a:link {
  color: white;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}
.home-card {
  display: flex;
  flex-direction: column;
  background: var(--light);
  color: white;
  border-radius: 8px;
  text-decoration: none;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
  transition: transform 250ms ease, box-shadow 250ms ease;
}
.home-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.45);
}
.home-card .image {
  height: 220px;
  overflow: hidden;
}
.home-card .image,
.home-card .image > .v-image {
  height: 220px;
}
.home-card .content {
  padding: 16px 18px;
  position: relative;
}
.home-card .content h2 {
  transition: color 200ms ease;
}
.home-card:hover .content h2 {
  color: #ddd6ff;
}
.home-card .content h2::after {
  content: "";
  display: block;
  width: 0;
  height: 3px;
  border-radius: 2px;
  background: linear-gradient(90deg, #8b7bd9, var(--medium));
  transition: width 250ms ease;
}
.home-card:hover .content h2::after {
  width: 42%;
}
.home-card .cta {
  text-decoration: underline;
  color: white;
}
.apply {
  text-decoration: underline;
  color: white;
}
.white-bg {
  background: white;
  display: flex;
  align-items: center;
}

.home-card .image ::v-deep .v-image__image {
  background-size: cover;
}
.about-img ::v-deep .v-image__image {
  background-position: center 80%;
}
.contact-img ::v-deep .v-image__image {
  background-position: center 70%;
}
.sponsor-img ::v-deep .v-image__image {
  background-size: contain !important;
  background-repeat: no-repeat;
  background-position: center;
}

/* Project card styling (for Join Us) */
.project-card {
  display: grid;
  grid-template-columns: 6px 1fr;
  background: var(--light);
  color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
  transition: transform 250ms ease, box-shadow 250ms ease;
}
.accent {
  background: linear-gradient(180deg, #8b7bd9, var(--medium));
}
.body {
  padding: 20px 22px;
}
.project-card .body h1 {
  position: relative;
  transition: color 200ms ease;
}
.project-card .body h1::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -6px;
  width: 0;
  height: 3px;
  border-radius: 2px;
  background: linear-gradient(90deg, #8b7bd9, var(--medium));
  transition: width 250ms ease;
}

/* Social card (fills empty space under Join Us) */
.social-card {
  margin-top: 18px;
  background: var(--light);
  color: white;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
  padding: 22px 20px 26px 20px;
  text-align: center;
}
.social-title {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 28px;
  line-height: 1;
  margin: 0 0 10px 0;
}
.yonder-y {
  width: 36px;
  height: 36px;
}
.address {
  color: #e9e9f6;
  opacity: 0.95;
  margin-bottom: 18px;
}
.icon-row {
  display: flex;
  justify-content: center;
  gap: 18px;
  flex-wrap: wrap;
}
.icon-link {
  text-decoration: none;
}
.icon-circle {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: white;
  display: grid;
  place-items: center;
  transition: transform 200ms ease, box-shadow 200ms ease, background 200ms ease;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.35);
}
.icon-circle:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.45);
}
.icon-circle .v-icon {
  color: #111;
  font-size: 26px;
}

@media (max-width: 960px) {
  .card-grid {
    grid-template-columns: 1fr;
  }
  .home-card .image {
    height: 180px;
  }
}
</style>
